import Vue from 'vue'

Vue.directive('closable', {
  bind (el, binding) {
    el.clickOutsideEvent = (event) => {
      // Check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        binding.value()
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
